import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Logo from './Logo';

const { FiLinkedin, FiInstagram } = FiIcons;

const Footer = () => {
  const socialLinks = [
    { icon: FiLinkedin, href: 'https://www.linkedin.com/company/togethrspace/', label: 'LinkedIn' },
    { icon: FiInstagram, href: 'https://www.instagram.com/togethrspace', label: 'Instagram' },
    { icon: FiIcons.FiUsers, href: 'https://togethr.mn.co/about', label: 'Mighty Networks' },
  ];

  return (
    <footer className="bg-purple-50 text-gray-900" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">Footer</h2>
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <Logo className="h-10 w-auto" />
          </div>
          <div className="flex space-x-6 justify-center mb-6">
            {socialLinks.map((item) => (
              <a key={item.label} href={item.href} className="text-gray-600 hover:text-purple-600">
                <span className="sr-only">{item.label}</span>
                <SafeIcon icon={item.icon} className="h-6 w-6" aria-hidden="true" />
              </a>
            ))}
          </div>
          <div>
            <p className="text-base text-gray-600 mb-6">&copy; {new Date().getFullYear()} Togethr. Community-owned and operated.</p>
            <div className="flex flex-col sm:flex-row justify-center items-center space-y-2 sm:space-y-0 sm:space-x-8 text-sm">
              <a href="https://togethr.space/#/privacy-policy" className="text-gray-600 hover:text-purple-600">Privacy Policy</a>
              <a href="https://togethr.space/#/cookie-policy" className="text-gray-600 hover:text-purple-600">Cookie Policy</a>
              <a href="#" className="text-gray-600 hover:text-purple-600">Terms of Service</a>
              <a href="#" className="text-gray-600 hover:text-purple-600">Community Guidelines</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;